import {
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	ToggleButton,
	ToggleButtonGroup,
	Avatar,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';
import { MdOutlinePlayCircleOutline } from 'react-icons/md';
import moment from 'moment';
import PlayingModal from './PlayingModal';
import { DotIcon } from '../../../Components/Icons/Icons';
import CultService from '../../../Services/CultService';
import { useSelector } from 'react-redux';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import NotesColumn from './NotesColumn';
import { USER_TYPE } from '../../../Utils/helper/AppConstants';
import CustomTablePagination from '../../../Components/CustomTablePagination';
import DepartmentTag from '../../../Components/DepartmentTag';
import recordIcon from '../../../Assets/Icons/record.svg';
import ViewNotes from '../../../Components/ViewNotes';
import CustomTag from '../../../Components/CustomTag';
import DataNotFound from '../../../Components/DataNotFound';
import { theme } from 'antd';

export default function CallRecordingsAlertList({
	recordings,
	height,
	fetch,
	hideUser,
	pagination,
	tabs,
	value,
	handleChangeTab,
}) {
	// console.log('recordings', recordings);
	const [selected, setSelected] = useState(null);
	const user = useSelector((state) => state.app.user);

	const handleAddComment = async ({ payload, onComplete }) => {
		payload = { ...payload, userId: user?._id };
		let res = await CultService.addComment({ data: payload });
		if (res.status == 200) {
			fetch();
			if (typeof onComplete == 'function') {
				onComplete();
			}
		}
	};

	return (
		<>
			<TableContainer
				sx={(theme) => ({
					minHeight: height,
					maxHeight: height,
					borderRadius: '14px',
					border: `1px solid ${theme.palette.primary.lighter_shade}`,
					backgroundColor: AppColors.WHITE,
					borderRadius: '0 0 10px 10px',
				})}
			>
				{recordings?.length === 0 ? (
					<DataNotFound />
				) : (
					<Table stickyHeader>
						{/* First Header: ToggleButtonGroup */}
						<TableHead
							sx={(theme) => ({
								cursor: 'none',
								position: 'sticky',
								top: 0,
								zIndex: 10,
								border: `1px solid ${theme.palette.primary.lighter_shade}`,
							})}
						>
							{/* <TableRow>
							<TableCell
								colSpan={7}
								sx={theme => ({
									borderBottom: `1px solid ${theme.palette.primary.lighter_shade}`,
									height: '50px',
									padding: 0,
                                 })}
							>
								<Stack direction="row" sx={{ width: '100%', height: '100%' }}>
									<ToggleButtonGroup
										size="small"
										value={value}
										exclusive
										border={0}
										onChange={handleChangeTab}
										sx={{ width: '100%', height: '100%' }}
									>
										{tabs?.map((tab, index) => (
											<ToggleButton
												key={index}
												sx={theme => ({
													textTransform: 'none',
													px: 2,
													alignItems: 'center',
													width: '50%',
													height: '100%',
													border: 0,
													backgroundColor: AppColors.NEW_BACKGROUND4,
													'&.Mui-selected': {
														backgroundColor: theme.palette.primary.lightest_shade,
														color: theme.palette.primary.darker_primary,
													},
                                                })}
												value={index}
											>
												<Typography fontSize={14} fontWeight={600} lineHeigh lineHeight={'150%'} color={theme.palette.primary.darker_primary}>
													{tab?.code}
												</Typography>
											</ToggleButton>
										))}
									</ToggleButtonGroup>
								</Stack>
							</TableCell>
						</TableRow> */}
						</TableHead>

						{/* Second Header: Existing Table Columns */}
						<TableHead
							sx={{
								'& .MuiTableCell-root': {
									fontSize: 14,
									color: AppColors.BLACK,
									fontWeight: 400,
									lineHeight: '150%',
									fontFamily: 'Poppins',
									paddingY: '8px',
									cursor: 'default',
								},
							}}
						>
							{!hideUser && <TableCell>Employee</TableCell>}
							<TableCell sx={{ whiteSpace: 'nowrap', maxWidth: '120px' }}>Campaign Name</TableCell>
							<TableCell>Summary</TableCell>
							{!hideUser && <TableCell>Department</TableCell>}
							<TableCell>Date</TableCell>
							<TableCell>Recording</TableCell>
							<TableCell>Notes</TableCell>
						</TableHead>

						{/* Table Body */}
						{/* {console.log('recordings', recordings)} */}
						<TableBody>
							{recordings?.map((c, index) => (
								<TableRow key={index} sx={{ '& .MuiTableCell-root': { verticalAlign: 'top' } }}>
									{!hideUser && (
										<TableCell>
											<UserThumbnail userId={c?.userId} user={{ firstName: c.name }} type="criticalSectionUser" />
										</TableCell>
									)}
									<TableCell>
										<Typography
											fontFamily={'Poppins'}
											fontSize={14}
											fontWeight={400}
											lineHeight={'150%'}
											color={AppColors.HEADING_TITLE4}
										>
											{c?.compaignId?.basicDetails?.name}
										</Typography>
									</TableCell>
									<TableCell sx={{ minWidth: '400px', maxWidth: '400px' }}>
										<Typography
											fontFamily={'Poppins'}
											fontSize={14}
											fontWeight={400}
											lineHeight={'150%'}
											color={AppColors.HEADING_TITLE4}
										>
											{c?.callSummary?.summary}
										</Typography>
									</TableCell>
									{!hideUser && (
										<TableCell>
											<CustomTag tagTitle={c?.department} />
										</TableCell>
									)}
									<TableCell>
										<Typography
											fontFamily={'Poppins'}
											fontSize={14}
											fontWeight={600}
											lineHeight={'150%'}
											color={AppColors.HEADING_TITLE4}
											whiteSpace={'nowrap'}
										>
											{moment(c?.call?.startedAt).format('MMM DD, YYYY')}
										</Typography>
									</TableCell>
									<TableCell sx={{ width: '100px' }}>
										<Stack
											sx={{
												pointerEvents: c?.name === USER_TYPE.ANONYMOUS ? 'none' : 'auto',
												opacity: c?.name === USER_TYPE.ANONYMOUS ? 0.2 : 1,
											}}
											direction="row"
											alignItems="center"
											gap={0.5}
										>
											<Avatar
												sx={(theme) => ({
													height: 30,
													width: 30,
													color: theme.palette.primary.darker_primary,
													borderRadius: 0,
													cursor: 'pointer',
												})}
												src={recordIcon}
												onClick={() => setSelected(c)}
											/>
											<Typography
												fontSize={14}
												fontWeight={600}
												lineHeight={'150%'}
												sx={(theme) => ({
													color: theme.palette.primary.darker_primary,
												})}
												whiteSpace="nowrap"
											>
												Recording {index + 1}
											</Typography>
										</Stack>
									</TableCell>

									<TableCell>
										<Stack gap={1} direction="row" alignItems="center">
											{!c?.anonymous && (
												<NotesColumn
													id={c._id}
													handleAddComment={handleAddComment}
													comments={c?.comments}
													campaign={c?.compaignId?.basicDetails}
												/>
											)}
											{!c?.anonymous && <ViewNotes comments={c?.comments} campaign={c?.compaignId?.basicDetails} />}
										</Stack>
									</TableCell>
								</TableRow>
							))}
							<TableRow
								sx={{
									position: 'sticky',
									bottom: 0,
									backgroundColor: '#fff',
									zIndex: 2,
								}}
							>
								<TableCell sx={{ paddingY: '4px' }} colSpan={12} align="center">
									<CustomTablePagination
										{...pagination}
										onChange={(p, r) => fetch(p, r)}
										onRowsPerPageChange={(e) => fetch(1, e.target.value)}
									/>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				)}
			</TableContainer>

			{/* <CustomTablePagination
				{...pagination}
				onChange={(p, r) => fetch(p, r)}
				onRowsPerPageChange={(e) => fetch(1, e.target.value)}
			/> */}
			<PlayingModal open={Boolean(selected)} onClose={() => setSelected(null)} selected={selected} />
		</>
	);
}
